<form
    role="search"
    [attr.aria-label]="tooltip | localize"
>
    <div
        class="agpr-filterDropdown"
        [ngClass]="{
            'agpr-filterDropdown--socialPlus': style === agprComponentStyle.socialPlus,
            'agpr-filterDropdown--disabled': disabled,
            'agpr-filterDropdown--hasFilters': hasFilters,
            'agpr-filterDropdown--inputGroupRight': inputGroupRight
        }"
        role="group"
        [attr.aria-describedby]="ariaDescribedBy"
    >
        <button
            #filterButton
            [id]="id + '.dropdownButton'"
            [disabled]="disabled"
            type="button"
            class="agpr-filterDropdown-button"
            [ngClass]="{
                'agpr-filterDropdown-button--withQuick': showQuickFilter && !hasFilters,
                'agpr-filterDropdown-button--withChips': hasFilters,
                'agpr-filterDropdown-button--disabled': disabled
            }"
            (click)="open()"
            [agprTooltip]="tooltip | localize"
            tooltipPosition="top"
        >
            <span [class]="iconClass + ' agpr-filterDropdown-buttonIcon'"></span>
        </button>

        <agpr-autocomplete
            *ngIf="showQuickFilter"
            #autocomplete
            [style]="style"
            [id]="id + '.quickFilter'"
            labelField="label"
            [suggestionsFetcher]="quickSuggestions"
            [placeholder]="quickFilterPlaceholder | localize"
            [autoHighlight]="true"
            [(ngModel)]="quickFilterQuery"
            [ngModelOptions]="{standalone: true}"
            [minLength]="minLength"
            maxlength="64"
            [disabled]="disabled"
            [ngClass]="{
                'agpr-filterDropdown-quick--withQuick': !hasFilters,
                'agpr-filterDropdown-quick--withChips': hasFilters
            }"
            [ariaLabel]="ariaLabel"
            [ariaLabelledBy]="ariaLabelledBy"
            panelStyleClass="agpr-filterDropdown-panel"
        ></agpr-autocomplete>
    </div>
    <div class="agpr-filterChips-activeFilterContainer"
        *ngIf="hasFilters"
    >
        <ng-container *ngFor="let filter of filters; let i = index">
            <ng-container *ngIf="filter.currentChips && filter.currentChips.length > 0">
                <label
                    [id]="id + '_filterDropdown_filterListLabel_' + i"
                    class="agpr-filterChips-activeFilterLabel"
                >
                    {{ filter.label | localize }}
                </label>
                <ul
                    [id]="id + '_activeFilters'"
                    class="agpr-filterChips-activeFilterContents"
                    [attr.aria-labelledby]="id + '_filterDropdown_filterListLabel_' + i"
                    agprListKeyboardNavigation
                    listOrientation="horizontal"
                    [focusOnChild]="true"
                    [list]="chips"
                >
                    <li
                        *ngFor="let chip of filter.currentChips; let i = index;"
                        [id]="id + '.chip_' + i"
                        class="agpr-chip"
                    >
                        <span class="agpr-chip-label">
                            {{ chip.label | localize:chip.labelArgs }}
                        </span>
                        <agpr-button
                            [id]="id + '.chip_' + i + '.delete'"
                            class="agpr-chip-button"
                            [style]="buttonTypes.icon"
                            icon="agpr-i-close"
                            tooltip="Common.forms.chips.delete"
                            tooltipPosition="top"
                            (click)="removeChip(filter, chip)"
                        ></agpr-button>
                    </li>
                </ul>
            </ng-container>
        </ng-container>
    </div>
</form>
